<div class="card" id="payments-due-today">
    <div class="card-body">
        <h2 class="card-title">Payments Due</h2>
    </div>

    <div class="card-body">
        <ul class="nav nav-tabs">
            @for (group of groupKeys; track group; let i = $index) {
            <li class="nav-item">
                <a class="nav-link" [class.active]="i === 0" [id]="group + '-tab'" data-toggle="tab" [attr.data-target]="'#group' + group" role="tab">  
                    @if (groups[group].url) {
                    <img [src]="groups[group].url" [alt]="groups[group].vehicle || null" />
                    }
                    @else {
                    <span class="material-icons">{{icon(groups[group].category)}}</span>
                    }
                </a>
            </li>
            }
        </ul>

        <div class="tab-content">
            @for (group of groupKeys; track group; let j = $index) {
            <div class="tab-pane fade" [class.show]="j === 0" [class.active]="j === 0" role="tabpanel" [attr.aria-labelledby]="group + '-tab-pane'" [id]="'group' + group">
                <div class="card">
                    <div class="card-header">
                        <div class="header-title-bar">
                            <div>
                                <p class="card-title">{{groups[group].title}}</p>
                                <p class="card-subtitle text-muted">{{groups[group].subtitle}}</p>
                            </div>
                            @if (groups[group].bhph) {
                            <report-drop-down [panel]="'forms'" [module]="'collections'" [saleId]="groups[group].saleId"></report-drop-down>
                            }
                        </div>
                        @if (groups[group].quote) {
                        <div class="badge-bar">
                            <a class="alert alert-warning quote-status" [routerLink]="['/quotes/', groups[group].saleId]">Sale Stage is <strong>Quote</strong></a>
                        </div>
                        }
                        @else {
                        <div class="badge-bar">
                            @if (groups[group].bhph) {
                                <div class="alert alert-secondary recompute" (click)="recompute($event, groups[group].termsId)">Recompute Receivables</div>
                            }
                            @if (groups[group].financed) {
                                <div class="alert alert-{{insuranceClass(groups[group])}} ins-state" [routerLink]="['/sales', groups[group].saleId, 'insurance']">{{insuranceMessage(groups[group])}}</div>
                            }
                        </div>
                        }
                    
                        @if (groups[group].financed) {
                            <ul class="terms">
                                @if (groups[group].financed && !groups[group].bhph && groups[group].lienholder) {
                                    <li>{{groups[group].lienholder}}</li>
                                }
                                <li>{{groups[group].method}} ({{groups[group].type}})</li>
                                <li>
                                    <span>{{groups[group].quote ? 'Quoted' : 'Sold'}}</span>
                                    <span class="numeric">{{groups[group].sold | date:'E MMM d, yyyy'}}</span>
                                </li>
                                <li>
                                    <span>{{groups[group].frequency}} Payment Amount</span>
                                    <span class="numeric">{{groups[group].payment | currency }}</span>
                                </li>
                                @if (!groups[group].quote) {
                                <li>
                                    <span>Riding Cash</span>
                                    <span class="numeric">{{groups[group].ridingCash | currency }}</span>
                                </li>
                                }
                                <li>
                                    <span>Principal Balance</span>
                                    <span class="numeric">{{groups[group].balance | currency }}</span>
                                </li>
                                <li>
                                    <span>Tax Balance</span>
                                    <span class="numeric">{{groups[group].tax | currency }}</span>
                                </li>
                                <li>
                                    <span>Unearned Interest</span>
                                    <span class="numeric">{{groups[group].unearnedInterest | currency }}</span>
                                </li>
                                @if (!groups[group].quote) {
                                <li>
                                    <span>Unpaid Earned Interest</span>
                                    <span class="numeric">{{groups[group].unpaidEarnedInterest | currency }}</span>
                                </li>
                                }
                                @if (!groups[group].quote) {
                                <li>
                                    <span>Unpaid Late Fees</span>
                                    <span class="numeric">{{groups[group].lateFees | currency }}</span>
                                </li>
                                }
                                <li>
                                    <span>Payoff</span>
                                    <span class="numeric">{{groups[group].payoff | currency }}</span>
                                </li>
                                <li>
                                    <span>Payment Balance</span>
                                    <span class="numeric">{{groups[group].paymentBalance | currency }}</span>
                                </li>
                                <li>
                                    <span>Annual Percentage Rate</span>
                                    <span class="numeric">{{groups[group].apr | number: '1.0-4' }}%</span>
                                </li>
                                <li>
                                    <span>% Principal Paid</span>
                                    <span class="numeric">{{groups[group].percentPrincipalPaid | number: '1.0-2' }}%</span>
                                </li>
                            </ul>
                        }
                        @else {
                            <ul class="terms">
                                <li>{{groups[group].type}}</li>
                                <li>
                                    <span>Sold</span>
                                    <span class="numeric">{{groups[group].sold | date:'E MMM d, yyyy'}}</span>
                                </li>
                            </ul>
                        }
                    </div>
                    <div class="card-body">
                        <div class="badge-bar">
                            @if (security.permitted('collections', 'take payment', 'update')) {
                                <div class="alert alert-secondary" [routerLink]="['/terms/', groups[group].termsId, 'payments']">
                                    <span class="material-icons">edit</span>
                                    <span>Edit payments</span>
                                </div>
                            }

                            @if (groups[group].bhph && (groups[group].payoff > 0)) {
                                <div class="alert alert-secondary" (click)="payoff($event, groups[group].termsId)">
                                    <span class="material-icons-outlined">payments</span>
                                    <span>Mark Paid Off {{groups[group].payoff | currency }}</span>
                                </div>
                            }
                        </div>

                        <ul class="list-group list-group-flush pay-list">
                            @for (payment of groups[group].payments; track payment) {
                                @if (payment.amount > 0) {
                                    <li class="list-group-item">
                                        <p class="due {{dueToClass(payment.due)}}" title="{{daysPastDue(payment.due)}}d">
                                            @if (dueToClass(payment.due) !== 'past') {
                                                <span class="d-none d-xl-inline-block">{{payment.due | date:'E MMM d, yy'}}</span>
                                                <span class="d-inline-block d-xl-none">{{payment.due | date:'M/d'}}</span>
                                            }
                                            @if (dueToClass(payment.due) === 'past') {
                                                <span class="d-none d-xl-inline-block">{{payment.due | date:'MMM d, yy'}}</span>
                                                <span class="d-inline-block d-xl-none">{{payment.due | date:'M/d'}}</span>
                                            }
                                            @if (daysPastDue(payment.due) > 0) {
                                                <span class="days">{{daysPastDue(payment.due)}}d</span>
                                            }
                                        </p>
                                        <p class="text-center">{{payment.category | lowercase}}</p>
                                        <div class="currency">
                                            <p class="title">{{payment.amount | currency}}</p>
                                            @if ((payment.status == 'Partially Paid') && (payment.paid > 0)) {
                                                <p class="subtitle">partially paid {{payment.paid | currency}}</p>
                                            }
                                        </div>
                                    </li>
                                }
                            }
                        </ul>
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
</div>

<recompute-modal [entry]="entry" [termsId]="entryTermsId" (recomputed)="recomputed($event)"></recompute-modal>

<button id="toggleGpsDeviceView" data-target="#viewGpsDevicesModal" data-toggle="modal" class="d-none"></button>
<div class="modal fade" data-backdrop="static" id="viewGpsDevicesModal" tabindex="-1" role="dialog" aria-labelledby="viewDevices">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <gps-devices-modal [vehicleId]="vehicleId"></gps-devices-modal>
            </div>
        </div>
    </div>
</div>

<button id="togglePayoffView" data-target="#viewPayoffModal" data-toggle="modal" class="d-none"></button>
<div class="modal fade" data-backdrop="static" id="viewPayoffModal" tabindex="-1" role="dialog" aria-labelledby="viewPayoff">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <payoff-modal [receivable]="payoffReceivable" (paidOff)="paidOff($event)"></payoff-modal>
            </div>
        </div>
    </div>
</div>
